'use client';

import React, {ReactNode} from 'react';

export interface ConfirmWithUserRequest {
	title: ReactNode;
	message: ReactNode;
	confirmButtonLabel?: ReactNode;
	rejectButtonLabel?: ReactNode;
	options?: Record<string, ReactNode>;
	size?: 'sm' | 'md' | 'lg';
}

export interface UserInputRequest {
	title: ReactNode;
	value?: string;
	placeholder?: string;
	confirmButtonLabel?: ReactNode;
	rejectButtonLabel?: ReactNode;
}

export interface UserInteractionContextProps {
	isOpen: boolean;
	confirmWithUser: (options: ConfirmWithUserRequest) => Promise<boolean | string>;
	requestUserInput: (options: UserInputRequest) => Promise<string | boolean>;
	notifyUser: (message: string, props?: {fixed?: boolean; delay?: number}) => void;
}

export const UserInteractionContext = React.createContext<UserInteractionContextProps | null>(null);
